<template>
  <a
    :href="url"
    :target="target"
    class="VcLink"
    :class="{ 'link-secondary': secondary, disabled: disabled }"
    :data-qa="dataQa"
    @click="(event) => $emit('click', event)"
    :role="!url ? 'button' : null"
    :tabindex="!url ? '0' : null"
    @keyup.enter.space="!url ? handleClick : null">
    <VcIcon v-if="!!prependIcon" class="VcLink-icon prepend-icon" small>{{ prependIcon }}</VcIcon>
    <label>{{ label }}</label>
    <VcIcon v-if="!!appendIcon" class="VcLink-icon append-icon" small>{{ appendIcon }}</VcIcon>
  </a>
</template>

<script>
import VcIcon from '../VcIcon/VcIcon.vue';
export default {
  name: 'VcLink',
  components: { VcIcon },
  props: {
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: false,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    prependIcon: {
      type: String,
      required: false,
    },
    appendIcon: {
      type: String,
      required: false,
    },
    dataQa: {
      type: String,
      default: 'VcLink',
    },
    target: {
      type: String,
      default: '_blank',
      validator: (target) => ['_blank', '_self', '_parent', '_top', '_system'].includes(target),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.VcLink {
  // FIXME: Change to inline-flex https://myvcita.atlassian.net/browse/VCITA2-2648
  display: flex;
  align-items: center;
  font-size: var(--font-size-x-small);
  font-weight: var(--font-weight-medium2);
  padding-top: var(--size-value1);
  text-decoration: none;
  color: var(--link-color);

  &.link-secondary {
    color: var(--gray-darken-4);

    &.VcLink {
      ::v-deep {
        svg path {
          fill: var(--gray-darken-4);
        }
      }
    }
  }

  &:hover label {
    text-decoration: underline;
    cursor: pointer;
  }

  .VcLink-icon {
    ::v-deep {
      svg path {
        fill: var(--link-color);
      }
    }
  }

  .prepend-icon {
    padding-inline-end: var(--size-value1);
  }

  .append-icon {
    padding-inline-start: var(--size-value1);
  }

  &.disabled {
    pointer-events: none;
  }
}
</style>
